import arborizacao from "../../../mockups/paineis/Frame 70_transparente.png"

export default function ArborizacaoUrbana({ getImagem }) {
  return (
    <div className="flex justify-center px-16 py-10">
      {/* <div className="border border-grayLight rounded-3xl overflow-hidden">
        <header className="bg-blue text-white py-6 text-center">
          <h1 className="text-4xl font-bold">Arborização urbana</h1>
        </header>

        <div className="p-10">
          <div className="grid grid-cols-2 gap-y-12">
            ITEM 1
            <div className="flex items-center justify-center gap-6">
              <img
                src={getImagem(4)}
                className="h-[130px] rounded-3xl"
                alt="Imagem de uma árvore plantada"
              />

              <div>
                <h1 className="text-5xl font-bold text-deepBlue">+400 mil</h1>
                <p className="text-2xl font-semibold text-deepBlue">
                  árvores plantadas
                </p>
                <p className="text-[20px] text-greenDark">
                  plantio arbóreo (desde 2021)
                </p>
              </div>
            </div>

            ITEM 2
            <div className="flex items-center justify-center gap-6">
              <img
                src={getImagem(5)}
                className="h-[130px] rounded-3xl"
                alt="Imagem de um bosque urbano"
              />

              <div>
                <div className="flex items-end gap-3">
                  <h1 className="text-6xl font-bold text-deepBlue">12</h1>
                  <div>
                    <p className="text-2xl font-semibold text-deepBlue">
                      bosques urbanos
                    </p>
                  </div>
                </div>
                <p className="text-[20px] text-greenDark">mini florestas</p>
              </div>
            </div>

            ITEM 3
            <div className="flex items-center justify-center gap-6">
              <img
                src={getImagem(6)}
                className="h-[130px] rounded-3xl"
                alt="Imagem de mudas de árvores"
              />

              <div>
                <h1 className="text-5xl font-bold text-deepBlue">+5 milhões</h1>
                <p className="text-2xl font-semibold text-deepBlue">
                  de mudas produzidas
                </p>
                <p className="text-[20px] text-greenDark">
                  produção e herbário (desde 2021)
                </p>
              </div>
            </div>

            ITEM 4
            <div className="flex items-center justify-center gap-6">
              <img
                src={getImagem(7)}
                className="h-[130px] rounded-3xl"
                alt="Imagem de jardins de chuva"
              />

              <div>
                <h1 className="text-5xl font-bold text-deepBlue">517+</h1>
                <p className="text-2xl font-semibold text-deepBlue">
                  jardins de chuva
                </p>
                <p className="text-[20px] text-greenDark">
                  permeabilidade urbana
                </p>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <img src={arborizacao} alt="" />
    </div>
  );
}
